import React from "react";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";
import Root from "./root.component";

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundary(err: Error, info: { componentStack: string }, props: unknown) {
    // Customize the root error boundary for your microfrontend here.
    console.log(`${err} ${info} ${props}`);
    return null;
  }
});

export const { bootstrap, mount, unmount } = lifecycles;
export { checkIfUserIsAdmin } from "./util/isAdminUser";
